import type { Business } from '~/shared/types'

/**
 * Whether the business has to set up its first profile before it may use the dashboard. Never for
 * an admin viewing a business; a profile already listed counts even before the business reloads.
 */
export function needsProfileSetup(
  business: Pick<Business, 'hasProfile'> | null | undefined,
  profileCount: number,
  adminViewing: boolean,
): boolean {
  if (adminViewing || !business) return false
  return !business.hasProfile && profileCount === 0
}

/** Where the guided setup goes once the first profile exists. */
export function afterProfileSetup(
  business: Pick<Business, 'companyDetailsPending'> | null | undefined,
): '/setup/company' | '/dashboard' {
  return business?.companyDetailsPending ? '/setup/company' : '/dashboard'
}
